// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"trainingGraph_wrapper__3q8B-"};